<template>
  <div class="form-container">
    <h2>Asociar Apodo a Dispositivo</h2>

    <div class="form-group">
      <label>MAC Ficticia:</label>
      <input
        type="text"
        v-model="clientForm.mac_serie"
        placeholder="Ejemplo: sBle000001"
      />
    </div>

    <div class="form-group">
      <label>Tipo de Dispositivo:</label>
      <select v-model="clientForm.tipo_dispositivo">
        <option value="SmartBle">SmartBle</option>
        <option value="Reader">Reader</option>
      </select>
    </div>

    <div class="form-group">
      <label>Apodo:</label>
      <div class="input-with-button">
        <input
          type="text"
          v-model="clientForm.apodo"
          placeholder="Ej: 20014-008"
        />
        <button @click="startScanner" type="button">📷 Escanear</button>
      </div>
    </div>

    <!-- Zona oculta para la cámara -->
    <div id="reader" style="width: 300px; margin: auto; display: none"></div>

    <div class="form-group">
      <label>Estado:</label>
      <select v-model="clientForm.estado">
        <option value="Activado">Activado</option>
        <option value="Desactivado">Desactivado</option>
      </select>
    </div>

    <!-- Campo para la Etiqueta actual -->
    <div class="form-group">
      <label>Etiqueta:</label>
      <input
        type="text"
        v-model="clientForm.etiqueta"
        placeholder="Etiqueta actual"
      />
    </div>

    <div v-if="clientForm.tipo_dispositivo === 'Reader'" class="form-group">
      <label>Latitud:</label>
      <input type="number" v-model="clientForm.lat" placeholder="Ej: 40.1234" />
    </div>

    <div v-if="clientForm.tipo_dispositivo === 'Reader'" class="form-group">
      <label>Longitud:</label>
      <input type="number" v-model="clientForm.lon" placeholder="-3.5678" />
    </div>

    <button @click="updateDeviceDetails">Guardar / Actualizar</button>

    <p v-if="saveMessage" class="success-message">
      {{ saveMessage }}
    </p>
  </div>
</template>

<script>
import api from "@/services/api.js";
import { Html5Qrcode } from "html5-qrcode";

export default {
  name: "DispositivoCliente",
  data() {
    return {
      clientForm: {
        mac_serie: "",
        tipo_dispositivo: "SmartBle",
        apodo: "",
        estado: "Activado",
        etiqueta: "",
        lat: null,
        lon: null,
      },
      saveMessage: "",
      scanner: null,
      scanning: false,
    };
  },
  async mounted() {
    const macParam = this.$route?.query?.mac;
    if (macParam) {
      this.clientForm.mac_serie = macParam;
      try {
        const data = await api.getDeviceDetails(macParam);
        console.log(data); // Para ver la respuesta completa
        this.clientForm.apodo = data.Apodo;
        this.clientForm.tipo_dispositivo = data.TipoDispositivo;
        // Asignamos "Valor" a "estado"
        this.clientForm.estado = data.Valor;
        this.clientForm.etiqueta = data.Etiqueta;
        this.clientForm.lat = data.Lat;
        this.clientForm.lon = data.Lon;
      } catch (error) {
        console.error("Error al obtener detalles del dispositivo:", error);
      }
    }
  },
  unmounted() {
    // Parar cámara si salimos del componente
    if (this.scanner && this.scanning) {
      this.scanner.stop().catch(() => {});
      this.scanning = false;
    }
  },
  methods: {
    // Acepta "20019 157 0 000777" y también "20019157000777"
    // Espacios opcionales entre tokens.
    parseBarcode(texto) {
      const raw = String(texto).trim();
      // Grupos: [1]=familia, [2]=numero (posible con ceros)
      const reFlexible = /^\s*(\d+)\s*157\s*0\s*(\d+)\s*$/;
      const m = raw.match(reFlexible);
      if (!m) return null;

      const familia = m[1];
      const numeroSinCeros = m[2].replace(/^0+/, "") || "0";
      return `${familia}-${numeroSinCeros}`;
    },

    async updateDeviceDetails() {
      // Validación del formato del apodo usando expresión regular
      const apodoRegex = /^[0-9]+-[0-9]+$/;
      if (!apodoRegex.test(this.clientForm.apodo)) {
        alert(
          "El apodo debe tener el formato: números, un guion y números (ej: 20014-008)."
        );
        return;
      }

      if (!this.clientForm.mac_serie) {
        alert("Falta la MAC ficticia (mac_serie).");
        return;
      }

      const payload = {
        mac_serie: this.clientForm.mac_serie,
        tipo_dispositivo: this.clientForm.tipo_dispositivo,
        apodo: this.clientForm.apodo,
        estado: this.clientForm.estado,
        etiqueta: this.clientForm.etiqueta,
        lat: this.clientForm.lat,
        lon: this.clientForm.lon,
      };

      try {
        await api.updateDeviceDetails(payload);
        this.saveMessage = "¡Datos guardados correctamente!";
        setTimeout(() => {
          this.resetForm();
        }, 2000);
      } catch (error) {
        console.error(error);
        alert("No se pudo guardar. Por favor, intenta de nuevo.");
      }
    },

    async startScanner() {
      if (!this.scanner) {
        this.scanner = new Html5Qrcode("reader");
      }
      if (this.scanning) return;

      const config = { fps: 10, qrbox: 250 };

      document.getElementById("reader").style.display = "block";

      this.scanning = true;
      this.scanner
        .start(
          { facingMode: "environment" },
          config,
          (decodedText) => {
            console.log(`Código detectado: ${decodedText}`);

            const apodoFormateado = this.parseBarcode(decodedText);

            if (apodoFormateado) {
              this.clientForm.apodo = apodoFormateado;
            } else {
              alert(
                "El código escaneado no tiene el formato esperado (ej: '20019 157 0 000777' o '20019157000777')."
              );
            }

            this.scanner
              .stop()
              .then(() => {
                this.scanning = false;
                document.getElementById("reader").style.display = "none";
              })
              .catch((err) => console.error("Error al parar el scanner:", err));
          },
          (errorMessage) => {
            console.warn(`Error de lectura: ${errorMessage}`);
          }
        )
        .catch((err) => {
          this.scanning = false;
          console.error("No se pudo iniciar la cámara:", err);
        });
    },
    resetForm() {
      this.clientForm = {
        mac_serie: "",
        tipo_dispositivo: "SmartBle",
        apodo: "",
        estado: "Activado",
        etiqueta: "",
        lat: null,
        lon: null,
      };
      this.saveMessage = "";
    },
  },
  watch: {
    "clientForm.tipo_dispositivo"(newVal) {
      console.log("Tipo de dispositivo cambió a:", newVal);
    },
  },
};
</script>

<style scoped>
/* Tus estilos tal cual */
.form-container {
  max-width: 600px;
  margin: 30px auto;
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.form-container h2 {
  margin-bottom: 20px;
  text-align: center;
}
.form-group {
  margin-bottom: 15px;
}
.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.form-group input,
.form-group select {
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ddd;
  box-sizing: border-box;
}
button {
  padding: 10px 20px;
  background-color: #4caf50; /* verde */
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  margin-top: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
button:hover {
  background-color: #45a049;
  transform: scale(1.03);
}
.success-message {
  color: #4caf50;
  text-align: center;
  font-weight: bold;
}
.input-with-button {
  display: flex;
  align-items: center;
}
.input-with-button input {
  flex: 1;
}
.input-with-button button {
  margin-left: 8px;
  padding: 8px 12px;
}
</style>
